
import { defineComponent, PropType, computed } from 'vue'
import { requiredRule, nonNegativeRule, numberOnlyRule } from '@/modules/validations'
import { LocalScheduledPrice } from '@/components/_shared/form-fields/scheduled-prices.vue'
import moment from 'moment'
import FormFieldScheduledPriceMonth from '@/components/_shared/form-fields/scheduled-price-month.vue'
import { useAgreementModule } from '@/modules/agreements'
import config from '@/modules/_shared/config'
import { currencyCodeToSymbol } from '@/modules/_shared/helpers'

export default defineComponent({
    name: 'form-field-scheduled-price',
    components: { FormFieldScheduledPriceMonth },
    emits: ['update:modelValue', 'scheduled-prices:revalidate-form'],
    props: {
        modelValue: {
            type: Object as PropType<LocalScheduledPrice>,
            required: true
        },
        contextPrices: {
            type: Array as PropType<LocalScheduledPrice[]>,
            required: true,
            readonly: true
        },
        contextAgreementId: {
            type: String,
            required: true,
            readonly: true
        }
    },
    setup (props, { emit }) {
        const { currentAgreement } = useAgreementModule()
        const localModel = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value)
        })

        const validFromOptionsStartDate = moment().add(1, 'months').startOf('month')
        let validFromOptionsEndDate = validFromOptionsStartDate.clone().add(12, 'months').startOf('month')
        if (currentAgreement.value.invoicingPeriod >= 12) {
            validFromOptionsEndDate = validFromOptionsStartDate.clone().add(36, 'months').startOf('month')
        }

        const dateNotScheduledAlreadyValidator = (val: string) => {
            const datesScheduled = props.contextPrices.map(price => price.validFrom)
            let occurrences = 0
            for (let i = 0; i < datesScheduled.length; i++) {
                if (datesScheduled[i] === val) {
                    occurrences++
                }
            }

            return occurrences < 2 || 'There is already a price scheduled for selected date'
        }

        const itemChanged = () => {
            emit('scheduled-prices:revalidate-form')
        }

        return {
            requiredRule,
            localModel,
            currentAgreement,
            getDateOptions (date: string) {
                const nextMonth = moment().add(1, 'month').format('YYYY/MM')
                return date >= nextMonth
            },
            dateNotScheduledAlreadyValidator,
            validFromOptionsStartDate,
            validFromOptionsEndDate,
            itemChanged,
            numberOnlyRule,
            currency: computed(() => currencyCodeToSymbol(config.defaultCurrency))
        }
    },
    methods: {
        nonNegativeRule
    }
})
